<template>  
    <div class="slider__slide">
        <slot />
    </div>
</template>
<script>
export default {
    
}
</script>